import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "./components/layout/AdminLayout";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import Login from "./pages/auth/Login";

import Dashboard from "./pages/dashboard/Dashboard";


// master data
import CityMaster from "./pages/masterData/CityMaster";
import CountryMaster from "./pages/masterData/CountryMaster";
import StateMaster from "./pages/masterData/StateMaster";
import BanksMaster from "./pages/masterData/BanksMaster";
import BusinessTypeMaster from "./pages/masterData/BusinessTypeMaster";
import CategoryMaster from "./pages/masterData/CatgeoryMaster";
import SubcategoryMaster from "./pages/masterData/SubCategoryMaster";
import DesignationMaster from "./pages/masterData/DesignationMaster";
import DeliveryTimeline from "./pages/masterData/DeliveryTimeline";

import ContactUs from "./pages/ContactUs";

import BuyerItemMaster from "./pages/BuyerMaster/BuyerItemMaster"

// vendor
import Vendor from "./pages/Vendor/Vendor"
import ManagedVendors from "./pages/Vendor/ManagedVendors"

// CMS
import PageMaster from "./pages/cms/pageMaster/PageMaster";
import PageEditor from "./pages/cms/pageMaster/PageEditor";
import CaseStudyManager from "./pages/cms/caseStudy/CaseStudyManager";
import CaseStudyForm from "./pages/cms/caseStudy/CaseStudyForm"
import HomePageMaster from "./pages/cms/home/HomePageMaster"
import BlogCategoryPageMaster from "./pages/cms/blogCategory/BlogCategoryPageMaster"
import CaseStudyPageMaster from "./pages/cms/caseStudy/CaseStudyPageMaster";
import OurBrands from "./pages/cms/OurBrands";
import BuyerPageMaster from "./pages/cms/buyer/BuyerPageMaster";
import SupplierPageMaster from "./pages/cms/supplier/SupplierPageMasterPage"
import BlogPageMaster from "./pages/cms/blog/BlogPageMaster"
import CreateBlogPage from "./pages/cms/blog/CreateBlogPage";
import EditBlogPage from "./pages/cms/blog/EditBlogPage";
import IndustriesManager from "./pages/cms/IndustriesManager";
import Testimonials from "./pages/Testimonials";
import SupportInbox from "./pages/support/SupportInbox";
import CatalogPage from "./pages/catalog/CatalogPage";
import CatalogBrands from "./pages/catalog/CatalogBrands";
import CatalogProducts from "./pages/catalog/CatalogProducts";
import CatalogSupplierPricing from "./pages/catalog/CatalogSupplierPricing";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />

          {/* <Route element={<ProtectedRoute />}> */}
          <Route path="/" element={<AdminLayout />}>

            <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            <Route path="master" >

              <Route path="countries" element={<ProtectedRoute><CountryMaster /></ProtectedRoute>} />
              <Route path="state" element={<ProtectedRoute><StateMaster /></ProtectedRoute>} />
              <Route path="city" element={<ProtectedRoute><CityMaster /></ProtectedRoute>} />

              <Route path="category" element={<ProtectedRoute><CategoryMaster /></ProtectedRoute>} />
              <Route path="subcategory" element={<ProtectedRoute><SubcategoryMaster /></ProtectedRoute>} />
              <Route path="businesstype" element={<ProtectedRoute><BusinessTypeMaster /></ProtectedRoute>} />
              <Route path="designation" element={<ProtectedRoute><DesignationMaster /></ProtectedRoute>} />
              <Route path="bank" element={<ProtectedRoute><BanksMaster /></ProtectedRoute>} />
              <Route path="deliverytimeline" element={<ProtectedRoute><DeliveryTimeline /></ProtectedRoute>} />

            </Route>

            <Route path="/contactus" element={<ProtectedRoute><ContactUs /></ProtectedRoute>} />
            <Route path="/testimonials" element={<ProtectedRoute><Testimonials /></ProtectedRoute>} />
            <Route path="/support-inbox" element={<ProtectedRoute><SupportInbox /></ProtectedRoute>} />
            {/* rfq */}
            {/* <Route path="/rfq" element={<ProtectedRoute><RFQ /></ProtectedRoute>} /> */}
            <Route path="/buyer-item-master" element={<ProtectedRoute><BuyerItemMaster /></ProtectedRoute>} />

            <Route path="/vendors" element={<ProtectedRoute><Vendor /></ProtectedRoute>} />
            <Route path="/managed-vendors" element={<ProtectedRoute><ManagedVendors /></ProtectedRoute>} />

            <Route path="catalog">
              <Route index element={<ProtectedRoute><CatalogPage /></ProtectedRoute>} />
              <Route path="brands" element={<ProtectedRoute><CatalogBrands /></ProtectedRoute>} />
              <Route path="products" element={<ProtectedRoute><CatalogProducts /></ProtectedRoute>} />
            <Route path="supplier-pricing" element={<ProtectedRoute><CatalogSupplierPricing /></ProtectedRoute>} />
            </Route>


            {/* CMS */}
            <Route path="/cms/pages" element={<ProtectedRoute><PageMaster /></ProtectedRoute>} />
            <Route path="/cms/master/case-study" element={<ProtectedRoute><CaseStudyPageMaster /></ProtectedRoute>} />
            <Route path="/cms/master/buyer-page" element={<ProtectedRoute><BuyerPageMaster /></ProtectedRoute>} />
            <Route path="/cms/master/supplier-page" element={<ProtectedRoute><SupplierPageMaster /></ProtectedRoute>} />
            <Route path="/cms/master/home-page" element={<ProtectedRoute><HomePageMaster /></ProtectedRoute>} />
            <Route path="/cms/master/blog-page" element={<ProtectedRoute><BlogCategoryPageMaster/></ProtectedRoute>} />
            <Route path="/cms/industries" element={<ProtectedRoute><IndustriesManager /></ProtectedRoute>} />
            <Route path="/cms/our-brands" element={<ProtectedRoute><OurBrands /></ProtectedRoute>} />
            <Route path="/cms/case-studies" element={<ProtectedRoute><CaseStudyManager /></ProtectedRoute>} />
            <Route path="/cms/case-studies-detail" element={<ProtectedRoute><CaseStudyForm /></ProtectedRoute>} />
            <Route path="/cms/case-studies/new" element={<ProtectedRoute><CaseStudyForm /></ProtectedRoute>} />
            <Route path="/cms/case-studies/:id" element={<ProtectedRoute><CaseStudyForm /></ProtectedRoute>} />
            {/* <Route path="/cms/case-studies/:id" element={<ProtectedRoute><CaseStudyEditor /></ProtectedRoute>} /> */}
            <Route path="/cms/pages/new" element={<ProtectedRoute><PageEditor /></ProtectedRoute>} />
            <Route path="/cms/pages/:slug" element={<ProtectedRoute><PageEditor /></ProtectedRoute>} />
            <Route path="/cms/blog-page" element={<ProtectedRoute><BlogPageMaster /></ProtectedRoute>} />
            <Route path="/cms/blog-page/create" element={<ProtectedRoute><CreateBlogPage /></ProtectedRoute>} />
            <Route path="/cms/blog-page/edit/:slug" element={<ProtectedRoute><EditBlogPage /></ProtectedRoute>} />


            {/* <Route path="kyc" element= {<KYC/>} />
            <Route path="designation" element= {<Designation/>} />
            <Route path="bank-account" element= {<BankAccount/>} />
            <Route path="doc" element= {<Documents/>} />
            <Route path="income-doc" element= {<IncomeDoc/>} />
            <Route path="Letter-heads" element= {<LetterHeads/>} /> */}
            {/* </Route> */}


            <Route path="/" element={<Navigate to="/dashboard" replace />} />


          </Route>
          {/* </Route> */}

          {/* <Route path="*" element={<Navigate to="/dashboard" replace />} /> */}
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
